import { cn } from '@/lib/utils'

const getTitleTag = (
  titleTag?: '1' | '2' | '3' | '4' | '5' | '6' | '100'
): 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' => {
  if (!titleTag) {
    return 'h2'
  }
  const t = titleTag.toString()
  //@ts-expect-error titleTag is not typed
  const title: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' = cn({
    ['h1']: t === '1',
    ['h2']: t === '2',
    ['h3']: t === '3' || t === '100',
    ['h4']: t === '4',
    ['h5']: t === '5',
    ['h6']: t === '6'
  })
  return title
}

export default getTitleTag
